module.exports = __webpack_public_path__ + "static/img/a098.c7c1f1f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/s/a098.jpg
// module id = iG9W
// module chunks = 0